module.exports = __webpack_public_path__ + "static/media/TAPNYSwagDesignProcess.47f4dd65.jpeg";